<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiArchiveOutline, mdiHomeCityOutline } from "@mdi/js"
  import type { AddressRow } from "../../_shared/_logic/address-table-contract"
  import { archivePresentation } from "../../../../../../../../_shared/_logic/archive-presentation"

  let { row }: { row: AddressRow } = $props()

  const archiveTooltip = $derived.by(() => {
    if (!row.property?.archived_at) return row.address as string

    return archivePresentation(row.property.archived_at, row.property.archive_reason)
  })
</script>

<StatusTag
  variant="neutral"
  size="sm"
  label={(row.address as string) || "Keine Liegenschaft hinterlegt"}
  icon={row.property?.archived_at ? mdiArchiveOutline : mdiHomeCityOutline}
  color={row.property?.archived_at ? "#7b8794" : "#2563eb"}
  tooltipContent={archiveTooltip}
/>
